import { useSyncExternalStore } from "react";
import { getLabounConfig, subscribeLabounConfig, type LabounConfig } from "./laboun-mode.js";

/** Reaktivní přístup k laboun-mode configu (sdílený store). */
export function useLabounConfig(): LabounConfig {
  return useSyncExternalStore(subscribeLabounConfig, getLabounConfig, getLabounConfig);
}
